/**
 * Stein Paint Smart Cart — Phase 8.6 Final
 * Unobtrusive cart note only. No removal UI.
 * Removal logic preserved as internal utility.
 */
(function() {
  'use strict';

  var FIVE_GALLON_VARIANTS = [
    37934576500903,37934576631975,37934576730279,37934576959655,37934577025191,
    37934577090727,37934587838631,37934587871399,37934587904167,37934587936935,
    37934588100775,37934588133543,37934588166311,38023518879911,38023518978215,
    38023519043751,38023519174823,38023519305895,38023519371431,38023520551079,
    38023520583847,38023520616615,38023520649383,38023521042599,38023521075367,
    38023521271975,38023521337511,38023521403047,38023521960103,38023521992871,
    38023522025639,38023522058407,38023522091175,38023522975911,38023523008679,
    38023523041447,38023523074215,38023524548775,38023524581543,38023524843687,
    38023524876455,38023524909223,38023524941991,38069586854055,38069587148967,
    38069587280039,38103569531047,38103570186407,38103570448551,38103570743463,
    38103570907303,38103571005607,38103571136679,38103571333287,38103571398823,
    38103571497127,38138144587943,38138144620711,38138144653479,38138144686247,
    38138144850087,38138144882855,38138144915623,38138144948391,38138145013927,
    38160817782951,38168802033831,38168802164903,38168802197671,38168802459815,
    38168802492583,38168802558119,38168802590887,38168802754727,38168802787495,
    38168802820263,43468807307431,43468807340199,45713174954151,51311305490599,
    51311880634535,51311880700071,51311880765607,51311880831143,51311880896679,
    51311880962215,51311881027751,51322941046951,51322941079719,51322943864999,
    51322943897767,51322943930535,51322944094375,51322944192679,51322944290983,
    51322944585895,51322944618663,51322950942887,51322950975655,51322951008423,
    51322951041191,51322951073959,51322952712359,51322952745127,51322952777895,
    51323041284263,51323041317031,51323041349799,51323041382567,51323042627751,
    51323042660519,51323042693287,51323042726055,51323044004007,51323045544103,
    51323045937319,51323046592679,51323048460455,51323165409447,51323167768743,
    51323170652327,51454045651111,51454045683879,51454045716647,51454045749415,
    51454045782183,51454045814951,51454058922151,51508679901351,51508680982695,
    51508681015463,51508681048231
  ];

  var VARIANT_SET = new Set(FIVE_GALLON_VARIANTS);

  function findFiveGallonItems(cartItems) {
    return cartItems.filter(function(item) { return VARIANT_SET.has(item.variant_id); });
  }

  function getBanner() { return document.querySelector('[data-stein-smart-cart-banner]'); }
  function removeBanner() { var b = getBanner(); if (b) b.remove(); }

  function createNote() {
    var div = document.createElement('div');
    div.className = 'stein-smart-cart-note';
    div.setAttribute('data-stein-smart-cart-banner', '');
    div.setAttribute('role', 'note');
    div.innerHTML =
      '<div class="stein-smart-cart-note-content">' +
        '<div class="stein-smart-cart-note-icon">&#9432;</div>' +
        '<div class="stein-smart-cart-note-text">' +
          '5-gallon buckets: available for store pickup or eligible local delivery. Not available for shipping.' +
        '</div>' +
      '</div>';
    return div;
  }

  function injectNote(cartItems) {
    var fiveGallonItems = findFiveGallonItems(cartItems);
    if (fiveGallonItems.length === 0) { removeBanner(); return; }
    if (getBanner()) return;

    var note = createNote();
    var cartContainer = document.querySelector('.cartitems--container');
    if (cartContainer) {
      cartContainer.parentNode.insertBefore(note, cartContainer);
    } else {
      var cartTitle = document.querySelector('.cart-title');
      if (cartTitle) cartTitle.after(note);
    }
  }

  function init() {
    if (!document.body.classList.contains('template-cart')) return;
    fetch(window.Theme.routes.cart_url + '.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' }})
    .then(function(r) { return r.json(); })
    .then(function(cart) { injectNote(cart.items || []); })
    .catch(function(err) { console.error('Stein Smart Cart: init failed', err); });
  }

  window.addEventListener('cartcount:update', function(e) {
    if (e.detail && e.detail.items) injectNote(e.detail.items);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
